import React, { useEffect, useState } from "react";
import { fetchData, fetchTAMData } from "./fetchData";
import { RA } from "./RA";
import { TAM } from "./TAM";
import "./Auction.css";
import { Auction, TAM as TAMType } from "../../../models/auction";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import { formatDMY, PrimaryColor } from "../../../common";
import CalendarIcon from "../../../icons/calendor-icon.png";
import { DynamicDatePicker } from "../../../components/DatePicker";
const TABS = ["Reverse Auction", "TAM"];

export const formatDateString = (date: Date | undefined): string => {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    return ""; // Return empty string or a default date format if date is invalid
  }
  return date.toLocaleDateString("en-GB").split("/").reverse().join("-");
};

export function AuctionPage() {
  const [forecastData, setForecastData] = useState<Auction[]>([]);
  const [TAMData, setTAMData] = useState<TAMType[]>([]);
  const [RALoading, setRALoading] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<string>(TABS[0]);
  // const [startDate, setStartDate] = useState(new Date("2024-01-01"));
  // const [endDate, setEndDate] = useState(new Date("2024-02-29"));
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [state, setState] = useState([
    {
      startDate: new Date("2024-01-01"),
      // endDate: new Date() + 2 months to current date,
      endDate: new Date(),

      key: "selection",
    },
  ]);
  const [dateRange, setDateRange] = useState(state[0]);

  useEffect(() => {
    setRALoading(true);
    fetchData({
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    }).then((data) => {
      setForecastData(data);
      setRALoading(false);
    });
    setLoading(true);
    fetchTAMData({
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    }).then((data) => {
      const aa = data

        .slice()
        .sort(
          (a, b) =>
            new Date(a.date ?? "").getTime() - new Date(b.date ?? "").getTime()
        );

      setTAMData(aa);
      setLoading(false);

      setLoading(false);
    });
  }, [dateRange]);

  useEffect(() => {
    const handleCopyCutPaste = (e: any) => {
      e.preventDefault();
    };

    document.addEventListener("copy", handleCopyCutPaste);
    document.addEventListener("cut", handleCopyCutPaste);
    document.addEventListener("paste", handleCopyCutPaste);

    return () => {
      document.removeEventListener("copy", handleCopyCutPaste);
      document.removeEventListener("cut", handleCopyCutPaste);
      document.removeEventListener("paste", handleCopyCutPaste);
    };
  }, []);

  return (
    <div className="auction-container">
      <div className="header">
        <h1>TAM and DEEP</h1>
        <div className="selectButton">
          {TABS.map((tab, index) => (
            <div
              onClick={() => setSelectedTab(tab)}
              key={tab}
              style={{
                borderRadius:
                  index === 0
                    ? "8px 0px 0px 8px"
                    : index === TABS.length - 1
                    ? "0px 8px 8px 0px"
                    : undefined,
              }}
              className={selectedTab === tab ? "fiterActive" : "fiterInactive"}
            >
              {tab}
            </div>
          ))}
        </div>
        <DynamicDatePicker
          defaultDates={dateRange}
          setDate={(date) =>
            setDateRange({
              startDate: date[0].startDate,
              endDate: date[0].endDate,
              key: "selection",
            })
          }
        />
      </div>
      {selectedTab === TABS[0] ? (
        <RA
          forecastData={forecastData}
          startDate={dateRange.startDate}
          endDate={dateRange.endDate}
          loading={RALoading}
        />
      ) : (
        <TAM
          TAMData={TAMData}
          loading={loading}
          startDate={dateRange.startDate}
          endDate={dateRange.endDate}
        />
      )}
    </div>
  );

  // function onDateChange(e: React.ChangeEvent<HTMLInputElement>
  // ){
  //   e.stopPropagation();
  //   setStartDate(new Date(e.target.value))
  // }
}
